import {
   
    GET_DIRECT_INDIRECT_FAIL,
    GET_DIRECT_INDIRECT_REQUEST,
    GET_DIRECT_INDIRECT_SUCCESS,
    GET_SOURSE_REPORT_FAIL,
    GET_SOURSE_REPORT_REQUEST,
    GET_SOURSE_REPORT_SUCCESS,
    GET_ASSINGED_LOGS_FAIL,
    GET_ASSINGED_LOGS_REQUEST,
    GET_ASSINGED_LOGS_SUCCESS,
    GET_APA_LOGS_FAIL,
    GET_APA_LOGS_REQUEST,
    GET_APA_LOGS_SUCCESS
} from './type';

// import { HUBURL, URL } from '../../../config';
import {APISAAS_DOMAIN} from '../../../env'

const getDirectIndirect = (organization_id,start_date,end_date, yopmail) => {
    return (dispatch, getState) => {
        const { Auth: { user: { token } } } = getState();
        dispatch({
            type: GET_DIRECT_INDIRECT_REQUEST
        });
        return fetch(`${APISAAS_DOMAIN}api/report/directvsind/${organization_id}/?start_date=${start_date}&end_date=${end_date}&yopmail=${yopmail}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })

            .then(response => response.json().then(body => ({ response, body })))
            .then(({ response, body }) => {
                if (!response.ok) {
                    dispatch({
                        type: GET_DIRECT_INDIRECT_FAIL,
                        payload: body.error
                    });
                } else {
                    dispatch({
                        type: GET_DIRECT_INDIRECT_SUCCESS,
                        payload: body
                    });
                }
            });
    }
}
const sourceReport = (organization_id,start_date,end_date, yopmail) => {
    return (dispatch, getState) => {
        const { Auth: { user: { token } } } = getState();
        dispatch({
            type: GET_SOURSE_REPORT_REQUEST
        });
        return fetch(`${APISAAS_DOMAIN}api/report/source/status/${organization_id}/?start_date=${start_date}&end_date=${end_date}&yopmail=${yopmail}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })

            .then(response => response.json().then(body => ({ response, body })))
            .then(({ response, body }) => {
                if (!response.ok) {
                    dispatch({
                        type: GET_SOURSE_REPORT_FAIL,
                        payload: body.error
                    });
                } else {
                    dispatch({
                        type: GET_SOURSE_REPORT_SUCCESS,
                        payload: body
                    });
                }
            });
    }
}

const assignedReport = (organization_id,start_date,end_date, yopmail) => {
    return (dispatch, getState) => {
        const { Auth: { user: { token } } } = getState();
        dispatch({
            type: GET_ASSINGED_LOGS_REQUEST
        });
        return fetch(`${APISAAS_DOMAIN}api/report/assigned/${organization_id}/?start_date=${start_date}&end_date=${end_date}&yopmail=${yopmail}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })

            .then(response => response.json().then(body => ({ response, body })))
            .then(({ response, body }) => {
                if (!response.ok) {
                    dispatch({
                        type: GET_ASSINGED_LOGS_FAIL,
                        payload: body.error
                    });
                } else {
                    dispatch({
                        type: GET_ASSINGED_LOGS_SUCCESS,
                        payload: body
                    });
                    console.log("bodybody",body)
                }
            });
    }
}

const APAReport = (organization_id,start_date,end_date, yopmail) => {
    return (dispatch, getState) => {
        const { Auth: { user: { token } } } = getState();
        dispatch({
            type: GET_APA_LOGS_REQUEST
        });
        return fetch(`${APISAAS_DOMAIN}api/report/apa/${organization_id}/?start_date=${start_date}&end_date=${end_date}&yopmail=${yopmail}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })

            .then(response => response.json().then(body => ({ response, body })))
            .then(({ response, body }) => {
                if (!response.ok) {
                    dispatch({
                        type: GET_APA_LOGS_FAIL,
                        payload: body.error
                    });
                } else {
                    dispatch({
                        type: GET_APA_LOGS_SUCCESS,
                        payload: body
                    });
                }
            });
    }
}
export default {
  
    getDirectIndirect,
    sourceReport,
    assignedReport,
    APAReport

}